import createReducer from '../createReducer';
import {
  FETCH_POI,
  FETCH_POI_SUCCESS,
  FETCH_POI_FAILURE,
 } from '../../actions/cms/poi';

const initialState = {
  poi: {},
};

const handlers = {};

handlers[FETCH_POI] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_POI_SUCCESS] = (state, { poi }) => ({
  ...state,
  loading: false,
  poi,
});

handlers[FETCH_POI_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/cms/poi.js